"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDeleteModal = void 0;
var react_1 = __importDefault(require("react"));
var ModalConfirm_1 = require("../../../../../Modals/ModalConfirm");
var ConfirmDeleteModal = function (_a) {
    var showDeleteImageModal = _a.showDeleteImageModal, setShowDeleteImageModal = _a.setShowDeleteImageModal, handleDeleteSingleImage = _a.handleDeleteSingleImage;
    return (react_1.default.createElement(ModalConfirm_1.ModalConfirm, { title: "Are you sure you want to delete this image?", subTitle: "Once you delete an image it cannot be undone", onClose: function () {
            setShowDeleteImageModal(false);
        }, onConfirm: function () {
            handleDeleteSingleImage({
                publicUrl: showDeleteImageModal.publicUrl,
            });
            setShowDeleteImageModal(false);
        } }));
};
exports.ConfirmDeleteModal = ConfirmDeleteModal;
